import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Content, Form, FormSubmit, TextInputControl } from '@/core/components';

import { DepartmentSelectControl } from '../Nomen/Department/DepartmentSelectControl';
import { UserSelectControl } from '../Nomen/User/UserSelectControl';
import { DisciplineSchema } from './model/DisciplineSchema';

interface DisciplineFormProps extends FormSubmit<DisciplineSchema> {
  title: string;
}

export function DisciplineForm(props: DisciplineFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<DisciplineSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <TextInputControl<DisciplineSchema>
              name="name"
              label={t('disciplines.form.fields.name')}
              isSubmitting={isSubmitting}
            />
            <DepartmentSelectControl<DisciplineSchema>
              label={t('disciplines.form.fields.department')}
              name="department"
              isSubmitting={isSubmitting}
            />
            <UserSelectControl<DisciplineSchema>
              label={t('disciplines.form.fields.headOfDiscipline')}
              name="headOfDiscipline"
              isSubmitting={isSubmitting}
            />
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
